import {FleetOwnerPortalService} from "@bolteu/bolt-server-api-fleet-owner-portal";

import CampaignStatus = FleetOwnerPortalService.CampaignStatus;

export const ACTIVE_AND_UPCOMING_STATUSES = [CampaignStatus.ACTIVE, CampaignStatus.UPCOMING];
export const FINISHED_STATUSES = [CampaignStatus.FINISHED];
